import store from './store.js';

export const firebase = require("firebase");

const config = {
  apiKey: "AIzaSyCacuZvuZIIRwnLu1-VHhsszU_XW6d0b7g",
  authDomain: "vidpod-d8a2f.firebaseapp.com",
  databaseURL: "https://vidpod-d8a2f.firebaseio.com",
  storageBucket: "gs://vidpod-d8a2f.appspot.com",
};

firebase.initializeApp(config);

firebase.auth().onIdTokenChanged(user => {
  store.dispatch({
    type: 'AUTH_CHANGE',
    user: user
  })
})

export const database = firebase.database();




// WEBPACK FOOTER //
// ./src/firebase.js